import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";

export interface FenerumState {
  hasIntegration: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: FenerumState = {
  hasIntegration: false,
  isLoading: true,
  error: null,
};

export const checkFenerumIntegration = createAsyncThunk(
  "fenerum/checkIntegration",
  async () => {
    const { data } = await axios.get<{ has_integration: boolean }>(
      "/v1/integrations/fenerum/status/",
    );
    return data.has_integration;
  },
);

const fenerumSlice = createSlice({
  name: "fenerum",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkFenerumIntegration.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(checkFenerumIntegration.fulfilled, (state, action) => {
        state.hasIntegration = action.payload;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(checkFenerumIntegration.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to check integration";
      });
  },
});

export default fenerumSlice.reducer;
